import { Component, OnInit } from "@angular/core";
import { BaseService } from "src/app/Services/Base.service";
import { ISlider } from "src/app/Models/ISlider";
import { Router } from "@angular/router";
declare var $: any;

@Component({
  selector: "app-home-slider",
  templateUrl: "./slider.component.html",
  styleUrls: ["./slider.component.scss"]
})
export class SliderComponent implements OnInit {
  ngOnInit() {
    // throw new Error("Method not implemented.");

    this.data.push({
      id: "700d1fccc89a4ac0a1f74fb3c2e7a0ed",
      title: {
        ar: "الإبتكار",
        en: "Innovation"
      },
      descrption: {
        ar:
          " نستثمر للتعرف على مسببات المشاكل المعقدة التي يواجهها عملائنا، ونبحث عن أفضل الحلول العالمية ثم نعيد صياغتها بشكل يناسب آليات السوق السوداني الفريد من نوعه. فنسعى مع عملائنا لابتكار حلول جديدة، ثم تجربتها وتحسينها. ولكن العنصر الأهم في ابتكارتنا هو تواصلنا مع الاطراف المعنية للتاكد من نجاح واستمرارية الحلول المقدمة إليهم. ",
        en:
          "We invest through our Research & Development team root cause analysis exercise to develop a winning solution business requirement, then we develop a proof of concept based on the latest cutting edge technologies, Best practices and Lesson Learned out of our experiences, industry international standards, and a local taste of the Sudanese culture. "
      },
      image: "assets/images/slider/dream-come-true.svg",
      isActive: true
    });

    this.data.push({
      id: "e3b5d5b9c457453f945ecef52d48580d",
      title: {
        ar: "شغف النجاح",
        en: "Pioneering"
      },
      descrption: {
        ar:
          "نزعم على أن نكون الأفضل في تقديم كل ما من شأنه حل المشاكل الأكثر تعقيداً في مواجهة عملائنا، ونصر على تحويل هذه الحلول لواقع ناجح ومستدام في السوق، ولن نتوقف عن ذلك حتى يحقق عملائنا النجاح.",
        en:
          "Our Creativity enables us to envision the digital future in SUDAN, We are keen to involve our stakeholders and employees in this vision to assure our business growth, sustainability and commitments."
      },
      image: "assets/images/slider/office-man.svg",
      isActive: true
    });
  }
  lang: string;
  url: string;
  data: ISlider[];

  constructor(private base: BaseService, private res: Router) {
    this.data = new Array<ISlider>();
    this.url = this.base.url;
  }

  ngAfterContentChecked() {
    this.lang = this.base.getLang();
  }

  ngAfterViewInit() {
    $(".carousel").carousel({
      ride: true
    });
  }

  ArrowDown() {
    $("html, body")
      .stop()
      .animate({ scrollTop: $(".about").offset().top - 80 }, 500, "swing");
  }

  ngAfterViewChecked(): void {
    {
      // if (
      //   !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      //     navigator.userAgent
      //   )
      // ) {
      $(".first,#slider1 .fullScreen")
        .css("height", $(window).height() - 80)
        .css("width", $(window).width());
      // }
    }
  }

  link(link) {
    // console.info(link);
  }

  onLoading(id) {
    $("#" + id).fadeOut("slow");
  }
}
